import React from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";

const NoConfirmationFinal = ({
  isNoConfirmationFLOpen,
  setIsNoConfirmationFLOpen
}: {
  isNoConfirmationFLOpen: boolean;
  setIsNoConfirmationFLOpen: (open: boolean) => void;
}) => {
  return (
    <>
      <Dialog
        open={isNoConfirmationFLOpen}
        onClose={() => setIsNoConfirmationFLOpen(false)}
        maxWidth={false}
        fullWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "350px",
            maxWidth: "350px"
          }
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: "1.1rem",
            position: "relative",
            pb: 1
          }}
        >
          Confirmation
          <IconButton
            aria-label="close"
            onClick={() => setIsNoConfirmationFLOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            borderBottom: "none", // removes bottom line
            borderTop: "1px solid rgba(0, 0, 0, 0.12)" // keep only top line
          }}
        >
          {/* Green Shield Icon */}
          <Box sx={{ display: "flex", justifyContent: "left", mb: 3 }}>
            <ErrorIcon sx={{ fontSize: 64, color: "#B3261D" }} />
          </Box>

          {/* Question Text */}
          <Typography
            sx={{
              fontSize: "1.2rem",
              fontWeight: 600,
              color: "#222",
              mb: 2
            }}
          >
            Please finish the work before applying for Final NOC.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              borderRadius: "24px",
              backgroundColor: "#3A1C73",
              textTransform: "none",
              fontWeight: 500,
              width: "120px",
              marginBottom: 1,
              "&:hover": { backgroundColor: "#2a145c" }
            }}
            onClick={() => setIsNoConfirmationFLOpen(false)}
          >
            OK, Got it.
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NoConfirmationFinal;
